import script from "./esPlanningWaitingRooms.vue?vue&type=script&setup=true&lang=ts"
export * from "./esPlanningWaitingRooms.vue?vue&type=script&setup=true&lang=ts"

import "./esPlanningWaitingRooms.vue?vue&type=style&index=0&id=692a20e4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-692a20e4"]])

export default __exports__